/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LanguageResponse } from '../models/LanguageResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LanguagesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Languages
     * @returns LanguageResponse Successful Response
     * @throws ApiError
     */
    public listLanguages(): CancelablePromise<Array<LanguageResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/languages',
        });
    }

}
